import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["messagesContainer"];
  static values = { phoneId: String };

  addMessage(event) {
    event.preventDefault();

    const url = `/admin/support_agent/phones/textable_message_card?phone_id=${this.phoneIdValue}&index=${this.messagesContainerTarget.children.length}`;

    fetch(url, {
      method: "POST",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content"),
      },
    })
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html))
      .catch((error) => console.error("Error adding textable message card:", error));
  }

  removeMessage(event) {
    event.preventDefault();

    const messageCard = event.target.closest("[data-message-id]");
    if (!messageCard) return;

    const destroyField = messageCard.querySelector(
      "[data-support-agent--textable-messages-target='destroyField']"
    );
    const idField = messageCard.querySelector('input[name*="[id]"]');

    if (idField && idField.value) {
      // Persisted message - mark for destruction and hide
      destroyField.value = "1";
      messageCard.style.display = "none";
    } else {
      // New message - remove from DOM
      messageCard.remove();
    }
  }
}
